/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ size: NonNullable<unknown> }} Placeflyersprint2Inputs */

const en_placeflyersprint2 = /** @type {(inputs: Placeflyersprint2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Print (${i?.size})`)
};

const de_placeflyersprint2 = /** @type {(inputs: Placeflyersprint2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Drucken (${i?.size})`)
};

/**
* | output |
* | --- |
* | "Print ({size})" |
*
* @param {Placeflyersprint2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placeflyersprint2 = /** @type {((inputs: Placeflyersprint2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placeflyersprint2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placeflyersprint2(inputs)
	return de_placeflyersprint2(inputs)
});
export { placeflyersprint2 as "placeFlyersPrint" }